import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  isOperationalStructurePath,
  resolveOperationalModuleFromIndexPath,
} from "./operationalModulePicker.helpers";
import { OperationalModulePickerContext } from "./operationalModulePicker.definition";
import { OperationalModulePickerModal } from "./OperationalModulePickerModal";

export const OperationalModulePickerProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [manualModuleKey, setManualModuleKey] = useState<string | null>(null);

  const deepLinkModuleKey = resolveOperationalModuleFromIndexPath(
    location.pathname,
  );

  // manualModuleKey tem prioridade — permite reabrir o seletor mesmo em
  // /<slug>/:structureId (ex.: trocar de estrutura sem voltar à home).
  const activeModuleKey =
    manualModuleKey ??
    (isOperationalStructurePath(location.pathname) ? null : deepLinkModuleKey);

  const openPicker = useCallback((moduleKey: string) => {
    setManualModuleKey(moduleKey);
  }, []);

  const closePicker = useCallback(() => {
    setManualModuleKey(null);

    if (deepLinkModuleKey) {
      navigate("/");
    }
  }, [deepLinkModuleKey, navigate]);

  useEffect(() => {
    if (isOperationalStructurePath(location.pathname)) {
      setManualModuleKey(null);
    }
  }, [location.pathname]);

  const contextValue = useMemo(
    () => ({ openPicker, closePicker }),
    [openPicker, closePicker],
  );

  return (
    <OperationalModulePickerContext.Provider value={contextValue}>
      {children}
      {activeModuleKey ? (
        <OperationalModulePickerModal
          moduleKey={activeModuleKey}
          onClose={closePicker}
        />
      ) : null}
    </OperationalModulePickerContext.Provider>
  );
};
